import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import { useTranslation } from 'react-i18next'

const TelephoneInput = (props) => {
  const { t } = useTranslation('translation', { useSuspense: false })
  const [isPhoneInputHover, setIsPhoneInputHover] = useState(false)
  const phoneInputStyles = {
    width: '100%',
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    borderWidth: '2px',
    borderRadius: '0.5em',
    borderColor: props.error ? 'red' : isPhoneInputHover ? '#9e9e9e' : '#e0e0e0',
    boxShadow: 'none',
    outline: 'none'
  }


  return (
    <>
      <PhoneInput
        name='phone_no'
        country='it'
        inputStyle={phoneInputStyles}
        value=""
        enableSearch={false}
        onChange={(_, data, __, formattedValue) => props.onChange(formattedValue.split(" ").join(""), data)}
        onBlur={() => setIsPhoneInputHover(false)}
        onFocus={() => setIsPhoneInputHover(true)}
        onMouseEnter={() => setIsPhoneInputHover(true)}
        onMouseLeave={() => setIsPhoneInputHover(false)}
      />
      { props.error && <span className='text-danger text-sm'>{props?.errorMessage ?? t('required')}</span>}
    </>
  )
}

export default TelephoneInput